import { isNullOrWhitespace } from "../../common/stringOperations.ts";
import { TemplatePlanRequirement } from "../templates/Templates.types.ts";

export class FrameworkTemplateSaveModel {
    complianceAreas: Array<string> = [];
    templatePlanRequirements: Array<TemplatePlanRequirement> = [];
    languages: Array<FrameworkTemplateLanguage> = [];

    constructor(
        complianceAreas: Array<string> = [],
        templatePlanRequirements: Array<TemplatePlanRequirement> = [],
        languages: Array<FrameworkTemplateLanguage> | undefined
    ) {
        this.complianceAreas = complianceAreas;
        this.templatePlanRequirements = templatePlanRequirements;
        this.languages = languages?.map((x) => new FrameworkTemplateLanguage(x.name, x.description, x.twoLetterIsoLanguage)) ?? [
            new FrameworkTemplateLanguage("", "", "da"),
            new FrameworkTemplateLanguage("", "", "en"),
        ];
    }

    static createEmptyModel() {
        return new FrameworkTemplateSaveModel([], [], undefined);
    }

    withUpdates(updates: Partial<FrameworkTemplateSaveModel>): FrameworkTemplateSaveModel {
        return new FrameworkTemplateSaveModel(
            updates.complianceAreas ?? this.complianceAreas,
            updates.templatePlanRequirements ?? this.templatePlanRequirements,
            updates.languages ?? this.languages
        );
    }

    isInvalid() {
        return this.languages.some((language) => language.isNameInvalid());
    }
}

export class FrameworkTemplateLanguage {
    name: string;
    description: string | undefined;
    twoLetterIsoLanguage: string;

    constructor(name: string, description: string | undefined, twoLetterIsoLanguage: string) {
        this.name = name;
        this.description = description;
        this.twoLetterIsoLanguage = twoLetterIsoLanguage;
    }

    isNameInvalid() {
        return isNullOrWhitespace(this.name);
    }
}
